export default "__VITE_ASSET__CJtMyjSQ__"